module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare@2x-eb943c29a88ca8c24dfa2d43dbba3a46.png";